import { lazy } from "react";

export default [
    {
        path:"/org/struktur-organisasi",
        component:lazy(()=>import("../../views/orgs/structure/"))
    },
    {
        path:"/org/daftar-pegawai",
        component:lazy(()=>import("../../views/orgs/employee-list/"))
    },
]